import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
import headerLandscapeImage from '../../assets/header-landscape.png';
import footerLandscapeImage from '../../assets/footer-landscape.png';

export async function generateMentoringPDF(mentoringData, mentoringDetailsData, officeName) {
    const [headerBase64, footerBase64] = await Promise.all([
      getBase64Image(headerLandscapeImage),
      getBase64Image(footerLandscapeImage),
    ]);

    const arrayOfDetails = mentoringDetailsData.map(details => {
        return [
            { text: details.concern || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
            { text: formatDate(details.found_date), alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
            { text: details.recommendation || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
            { text: details.commitment || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11  },
            { text: details.timeline || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11  },
            { text: details.remarks || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11  },
        ];
    });

    const pageSize = { width: 936, height: 612 };

    const docDefinition = {
        defaultStyle: { font: "ArialNarrow" },
        pageSize: {
            width: 612,
            height: 936
        },
        info: {
            title: 'Mentoring for ' + getFacultyName(mentoringData.faculty),
        },
        pageOrientation: 'landscape',
        pageMargins: [35, 120, 35, 100],
        header: (currentPage, pageCount, pageSize) => {
          return {
              stack: [
                {
                    image: headerBase64,
                    width: pageSize.width - 30,
                    alignment: 'center',
                    margin: [0, 10, 0, 0]
                },
                {
                    text: officeName,
                    fontSize: 16,
                    bold: true,
                    alignment: 'center',
                    font: "CenturySchoolBook"
                }
              ]
          }
        },
        footer: {
            image: footerBase64,
            width: pageSize.width - 30,
            alignment: 'center',
            margin: [0, 25, 0, 0]
        },
        content: [
            { text: 'AMS Form 2', style: 'header', alignment: 'center', margin: [0, 0, 0, 2], bold: true },
            { text: 'Coaching, Mentoring, and Commitment Form', style: 'header', alignment: 'center', margin: [0, 0, 0, 10], bold: true },
            {
              text: [
                { text: "Name of Faculty: ", bold: true },
                { text: getFacultyName(mentoringData.faculty) },
              ],
              style: "subheader",
              margin: [0, 0, 0, 4],
            },
            {
              text: [
                { text: "Institute: ", bold: true },
                { text: mentoringData.office?.name || "" },
              ],
              style: "subheader",
              margin: [0, 0, 0, 4],
            },
            {
              text: [
                { text: "Date of Mentoring: ", bold: true },
                { text: formatDate(mentoringData.mentoring_date) },
              ],
              style: "subheader",
              margin: [0, 0, 0, 10],
            },
            {   
              table: {
                  headerRows: 1,
                  widths: ['*', 90 , '*', '*', '*', '*'],
                  body: [
                      [ 
                        {text: 'Concern', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                        {text: 'Date Identified', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                        {text: 'Coaching/Mentoring Description/Recommendation', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                        {text: 'Faculty Commitment', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                        {text: 'Timeline', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                        {text: 'Remarks/Date', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                      ],
                      ...arrayOfDetails
                  ],
              },
              layout: {
                  hLineWidth: () => 0.1,
                  vLineWidth: () => 0.1,
              }
            },
            {
              text: [
                { text: "Note: ", bold: true },
                { text: "Contents are confidential.", italics: true },
              ],
              fontSize: 11,
              style: "subheader",
              margin: [0, 0, 0, 10],
            },
            {
              layout: 'noBorders',
              style: 'esign',
              margin: [20, 10, 0, 0],
              table: {
                  widths: [ 200 , '*'],
                  body: [
                      [  
                          {
                              stack: [
                                  { 
                                      text: 'Prepared by:', 
                                      margin: [0, 0, 0, 20] 
                                  },
                                  {
                                      text: '_______________________________',
                                      alignment: 'left',
                                      margin: [0, 0, 0, 0]
                                  },
                                  {
                                      text: (mentoringData.office?.abbrev || "" ) + ' Dean',
                                      bold: false
                                  },
                                  
                              ],
                              alignment: 'left',
                              margin: [-20, 0, 0, 0]
                          },
                          {
                              stack: [
                                  { 
                                      text: 'Conformed:', 
                                      margin: [0, 0, 0, 20] 
                                  },
                                  {
                                      text: '_______________________________',
                                      alignment: 'left',
                                      margin: [0, 0, 0, 0]
                                  },
                                  {
                                      text: 'Faculty',
                                      bold: false
                                  },
                              ],
                              alignment: 'left',
                              margin: [-20, 0, 0, 0]
                          }
                      ],
                  ]
              }
          },
        ]
    };

    pdfMake.createPdf(docDefinition).open();
}

function formatDate(date) {
  if (!date) return "";
  const d = new Date(date);
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

function getFacultyName(faculty) {
  if (!faculty) return "";
  return `${faculty.fname} ${faculty.mname ? faculty.mname[0] + "." : ""} ${faculty.lname}${faculty.suffix ? ", " + faculty.suffix : ""}`;
}

function getBase64Image(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = url;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = error => reject(error);
    });
}